export default __webpack_public_path__ + "static/media/lamb-squash-spaghetti.f987963a.jpeg";